const EFFECTS = ['zoom_in', 'zoom_out', 'pan_left', 'pan_right'];

function shuffleArray(arr) {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export function generateConfig(preset, imageAssets, audioAssets, overrides = {}, tierResolution = '1920x1080') {
  const imageDuration = overrides.image_duration ?? preset.image_duration;
  const transitionDuration = overrides.transition_duration ?? preset.transition_duration;
  const sequencing = overrides.sequencing ?? preset.sequencing;

  let clips = imageAssets.map((asset, i) => ({
    id: 'clip_' + i,
    image: 'asset:' + asset.id,
    duration: imageDuration,
    effect: EFFECTS[i % EFFECTS.length],
  }));

  if (sequencing === 'shuffle') {
    clips = shuffleArray(clips);
  }

  // Assembly references clips by $id and stitches them with transitions + audio
  const assembly = {
    id: 'master',
    clips: clips.map((c) => '$' + c.id),
    output: 'master.mp4',
    video: {
      transition: 'crossfade',
      transition_duration: transitionDuration,
    },
  };

  if (audioAssets.length > 0) {
    assembly.audio = {
      files: audioAssets.map((a) => 'asset:' + a.id),
    };
  }

  return {
    clips,
    assemblies: [assembly],
    defaults: {
      clips: {
        resolution: tierResolution,
      },
    },
  };
}

export function generateExtendConfig(targetHours, masterOutputUrl, audioAssets = []) {
  const extendEntry = {
    input: masterOutputUrl,
    duration: targetHours + 'h',
    output: 'extended.mp4',
  };

  if (audioAssets.length > 0) {
    extendEntry.audio = {
      files: audioAssets.map((a) => 'asset:' + a.id),
    };
  }

  return { extend: [extendEntry] };
}
